/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Add_CustomerInputs */

const vi_dashboard_add_customer = /** @type {(inputs: Dashboard_Add_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm khách hàng`)
};

/**

* @param {Dashboard_Add_CustomerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_add_customer = /** @type {((inputs?: Dashboard_Add_CustomerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Add_CustomerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_add_customer(inputs)
});